import { primary } from "@/styles/variable"
import styled from "styled-components"

export const AddBtnWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 48px;
  margin-top: 24px;
  .add-btn {
    width: 100%;
    height: 100%;
    display: flex;
    padding: 8px 0px;
    justify-content: center;
    align-items: center;
    border-radius: 50px;
    border: none;
    outline: none;
  }
`
export const AddBtnText = styled.span`
  color: ${primary.black};
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`
